import { yupResolver } from '@hookform/resolvers/yup'
import type { EditHeaderProps } from 'components/Card'
import { FormProvider, useForm } from 'react-hook-form'
import { formatAddress } from 'utils'
import { PV1PrescriberEditForm } from './PV1PrescriberEditForm'
import { PV1PrescriberEditFormSchema, type PV1PrescriberEditFormSchemaType } from './PV1PrescriberEditForm.validator'

export const PV1PrescriberEdit = ({
  onSubmit,
  ...props
}: {
  rxPrescriberData: any
  pv1PrescriberCardData: any
  editHeaderActions: EditHeaderProps
  onSubmit: (data: PV1PrescriberEditFormSchemaType) => void
}) => {
  const methods = useForm<PV1PrescriberEditFormSchemaType>({
    resolver: yupResolver(PV1PrescriberEditFormSchema),
    reValidateMode: 'onChange',
    defaultValues: {
      prescriber: props.pv1PrescriberCardData.prescriber?.value || '',
      address: props.pv1PrescriberCardData.address?.value
        ? formatAddress(props.pv1PrescriberCardData.address?.value)
        : '',
    },
  })

  return (
    <FormProvider {...methods}>
      <PV1PrescriberEditForm {...props} onSubmit={methods.handleSubmit(onSubmit)} />
    </FormProvider>
  )
}
